import Lenis from 'lenis';

const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: true,
    smoothTouch: false,
    touchMultiplier: 2,
});

function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.querySelectorAll('.register-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
        lenis.scrollTo('#registerForm', { offset: -80 });
    });
});

export { lenis };
